module.exports = __webpack_public_path__ + "img/new-dfod-disabled.90518f7e.svg";